import Footer from "./footer";
// import BidsModal from "./modal/bidsModal";
// import BuyModal from "./modal/buyModal";
import Header01 from "./header/Header01";
import Head from "next/head";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import CancelModal from "./modal/cancelModal";
import LendingModal from "./modal/lendingModal";
import RejectModal from "./modal/rejectModal";
import AcceptTermsModal from "./modal/acceptTermsModal";

const modals = {
  CancelModal,
  RejectModal,
  LendingModal,
  AcceptTermsModal,
};

export default function Layout({ children }) {
  const { modal } = useSelector((state: any) => state.counter);
  const Modal = modals[modal?.key] || (() => null);

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.png" />
      </Head>
      <Toaster
        position={"top-right"}
        toastOptions={{
          duration: 2500,
        }}
      />
      <Header01 />
      {/* <Wallet_modal /> */}
      {/* <BidsModal />
      <BuyModal /> */}
      <Modal />
      {/* {Modal === "CancelModal" && <CancelModal />} */}
      <main>{children}</main>
      <Footer />
    </>
  );
}
